export default "__VITE_ASSET__c50cc213__"